// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"styles_externalLink__3Pg_l"};